import React, { PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

const Container = (props: PropsWithChildren) => {
  const { children } = props;
  const { minWidth } = useResponsive();

  return <View style={minWidth.isMD ? styles.columnsContainer : styles.stacked}>{children}</View>;
};

const LeftColumn = (props: PropsWithChildren) => {
  const { children } = props;
  const { minWidth } = useResponsive();

  return <View style={minWidth.isMD ? styles.leftColumn : styles.stacked}>{children}</View>;
};

const RightColumn = (props: PropsWithChildren) => {
  const { children } = props;
  const { minWidth } = useResponsive();

  return <View style={minWidth.isMD ? styles.rightColumn : styles.stacked}>{children}</View>;
};

export const SweetpassTwoColumnsLayout = {
  Container,
  RightColumn,
  LeftColumn,
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  columnsContainer: {
    flexDirection: 'row',
    flex: 1,
  },
  stacked: {
    gap: theme.spacing['6'],
  },
  leftColumn: {
    width: '50%',
    backgroundColor: theme.colors.LINEN,
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing['10'],
  },
  rightColumn: {
    width: '50%',
    gap: theme.spacing['10'],
    backgroundColor: theme.colors.APP_BACKGROUND,
    paddingTop: theme.spacing['30'],
    paddingBottom: theme.spacing['10'],
    paddingHorizontal: theme.spacing['15'],
  },
});
